import Box from '@mui/material/Box';
import { Feature, Subscription } from '../../../models';
import { ProductAddMoreBox } from './ProductAddMoreBox';
import { useLaunchDarkly } from '../../../launchdarkly';

export const AddMorePlan = (
  { subscriptions }: { subscriptions: Subscription[] },
) => {
  const { flags } = useLaunchDarkly();
  const hasTrueSubscription = subscriptions.some(
    it => it.feature === Feature.TRUE_TEAM || it.feature === Feature.TRUE_ENTERPRISE,
  );

  const selfServeFeatures = (hasTrueSubscription
    || (flags?.truePlatformEnabled && subscriptions.length === 0))
    ? Feature.trueSelfServeFeature : Feature.selfServeFeature;
  const directSaleFeatures = (hasTrueSubscription
    || (flags?.truePlatformEnabled && subscriptions.length === 0))
    ? Feature.trueDirectSaleFeature : Feature.directSaleFeature;

  return (
    <Box
      id="add-more-plan"
      key="add-more-plan"
      display="flex"
      flexDirection="column"
      flexWrap="wrap"
      width="100%"
      sx={theme => ({
        [theme.breakpoints.down('tablet')]: {
          flexDirection: 'column',
        },
        [theme.breakpoints.up('tablet')]: {
          flexDirection: 'row',
        },
      })}
    >
      {selfServeFeatures
        .filter(feature => !subscriptions
          .some(sub => sub.feature === feature))
        .map(feature => (
          <ProductAddMoreBox
            key={`add-more-plan-${feature}`}
            feature={feature}
            selfServe
          />
        ))}
      {directSaleFeatures
        .filter(feature => !subscriptions
          .some(sub => sub.feature === feature))
        .map(feature => (
          <ProductAddMoreBox
            key={`add-more-plan-${feature}`}
            feature={feature}
          />
        ))}
    </Box>
  );
};
